// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"139":"8c68d6113632810f","888":"b71e6ab9fc5dd0cd"}[chunkId] + ".css";
};